import { AnchorElementsSource } from 'owa-link-data';
import { DatapointStatus, logUsage, PerformanceDatapoint } from 'owa-analytics';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import { GetSharingInfoResponseBase } from 'owa-fileprovider-link-services';
import { lazyGetSharingInformation as lazyGetSharingInformationService } from 'owa-sharing-data';

export async function getSharingInformation(
    url: string,
    anchorElementsSource: AnchorElementsSource,
    shouldBeautify: boolean,
    shouldRehydrate: boolean,
    providerType: AttachmentDataProviderType
): Promise<GetSharingInfoResponseBase> {
    let response: GetSharingInfoResponseBase;
    let errorType: string = null;

    const expectedErrorType = getExpectedErrorType(url);
    const datapoint: PerformanceDatapoint = new PerformanceDatapoint(
        'GetSharingInformationForLink'
    );
    datapoint.addCustomData({
        anchorElementsSource: anchorElementsSource.toString(),
        shouldBeautify: shouldBeautify,
        shouldRehydrate: shouldRehydrate,
        expectedErrorType: expectedErrorType,
    });

    try {
        const getSharingInformationService = await lazyGetSharingInformationService.import();
        response = await getSharingInformationService(url, providerType);
    } catch (error) {
        errorType = error.fetchErrorType;
        response = {
            ResultCode: AttachmentResultCode.GenericFailure,
        };
    }

    if (
        response.ResultCode !== AttachmentResultCode.Success ||
        (providerType === AttachmentDataProviderType.OneDrivePro &&
            !(<GetSharingInfoResponse>response).CanonicalUrl)
    ) {
        if (
            response.ResultCode === AttachmentResultCode.Success &&
            providerType === AttachmentDataProviderType.OneDrivePro &&
            !(<GetSharingInfoResponse>response).CanonicalUrl
        ) {
            response.ResultCode = AttachmentResultCode.GenericFailure;
            errorType = 'NullCanonicalUrlFromSuccessResponse';
        }

        // Keeping this redundent datapoint while the new one rolls out.
        // VSO 53412 to track removing this
        logUsage('GetSharingInformationFailure', {
            errorType: errorType,
            resultCode: response.ResultCode,
            anchorElementsSource: anchorElementsSource.toString(),
            shouldBeautify: shouldBeautify,
            shouldRehydrate: shouldRehydrate,
            expectedErrorType: expectedErrorType,
        });

        datapoint.addCustomData({
            errorType: errorType,
            resultCode: response.ResultCode,
        });
        datapoint.endWithError(DatapointStatus.ServerError);
    } else {
        datapoint.addCustomData({
            errorType: null,
            resultCode: response.ResultCode,
        });
        datapoint.end();
    }
    return response;
}

function getExpectedErrorType(url: string): string {
    // some of the string checks might have different cases. This lets us check al of them consistently.
    const lowerCaseUrl = url.toLowerCase();
    const stringsToCheck = ['onedrive.aspx', 'onenote.aspx', 'allitems.aspx', 'all.aspx', 'sites'];
    for (const str of stringsToCheck) {
        if (lowerCaseUrl.indexOf(str) !== -1) {
            return str;
        }
    }
    return 'NoErrorExpected';
}
